import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'
import Text from './Text'

const styles = {
  view: {
    marginTop: 15,
    marginBottom: 15,
    flexDirection: 'row',
    display: 'flex',
  },
  column: {
    display: 'block',
  },
  icon: {
    marginRight: 8,
    fontSize: 12,
  },
  text: {
    marginTop: 4,
    fontSize: 10,
    marginRight: 24,
    color: colors.strongGray,
  },
  title: {
    color: colors.strongYellow,
    fontSize: 12,
    fontFamily: 'Inter-Bold',
    margin: 0,
  },
  line: {},
}

export const Important = ({ textColor, date, icon }) => {
  return (
    <div style={styles.view}>
      <div style={styles.icon}>{icon && icon(textColor)}</div>
      <div style={styles.column}>
        <Text style={styles.title}>IMPORTANTE</Text>
        <Text style={styles.text}>
          Agende suas consultas ou exames com a Unimed Assis através do
          telefone&nbsp;
          <Text
            style={{
              fontFamily: 'Inter-Bold',
              display: 'inline-block',
              margin: 0,
            }}
          >
            (18) 99709-1663
          </Text>
          &nbsp;ou pelo e-mail&nbsp;
          <Text
            style={{
              fontFamily: 'Inter-Bold',
              display: 'inline-block',
              margin: 0,
            }}
          >
            medicina.preventiva@unimed-assis.com.br
          </Text>
          . Para realizar qualquer procedimento no Ambulatório Essencial, é
          necessário levar os resultados dos exames realizados anteriormente.
          Este é um resultado preliminar com base nos dados coletados dia
          {' '}
          {date}
          . Para ter um diagnóstico completo sobre sua saúde, não deixe de
          seguir as recomendações contidas neste relatório e realizar consultas
          periódicas com seu médico.
        </Text>
      </div>
    </div>
  )
}

Important.propTypes = {
  date: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  icon: PropTypes.func,
}

Important.defaultProps = {
  icon: null,
  textColor: colors.titleStrongBlack,
}
